import api from './api';

export const customizationsService = {
    getAll: async () => {
        const response = await api.get('/admin/customizations');
        return response.data;
    },

    getById: async (id) => {
        const response = await api.get(`/admin/customizations/${id}`);
        return response.data;
    },

    create: async (data) => {
        const response = await api.post('/admin/customizations', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/admin/customizations/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`/admin/customizations/${id}`);
        return response.data;
    },

    // Bulk assignment endpoints
    getAssignedProducts: async (id) => {
        const response = await api.get(`/admin/customizations/${id}/products`);
        return response.data;
    },

    bulkAssign: async (id, assignments) => {
        const response = await api.post(`/admin/customizations/${id}/bulk-assign`, { assignments });
        return response.data;
    },

    removeAssignment: async (id, product_id) => {
        const response = await api.post(`/admin/customizations/${id}/remove-assignment`, { product_id });
        return response.data;
    }
};

export default customizationsService;
